module.exports = __webpack_public_path__ + "media/images/group-2-fa0a23aa.png";